import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IUpdateExpiredPasswordParams {
  username: string;
  oldEncryptedPassword: string;
  newEncryptedPassword: string;
  encryptionKeyId: string;
}

export class UpdateExpiredPasswordRequest extends Request<IUpdateExpiredPasswordParams, IResult> {
  constructor(params: IUpdateExpiredPasswordParams) {
    super('updateExpiredPassword', params);
  }
}
